<template>
  <div class="panel-body">
    <v-card>
      <template>
        <v-container>
          <v-row>
            <v-card>
            Group Exclusion
            </v-card>
          </v-row>
          <v-row>
            <v-col>
              <v-card>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        :items="this.sourceGroups"
                        item-text="name"
                        item-value="id"
                        label="Source Group"
                        v-model="sourceGroupModel"
                        required
                        :disabled="this.exclusion != null"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="this.targetGroups"
                        clearable
                        @click:clear="clearExcludedGroup()"
                        label="Excluded Group"
                        item-text="name"
                        item-value="id"
                        v-model="excludedGroupModel"
                        color="primary"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayStartDateTime"
                            label="Start Date"
                            persistent-hint
                            hint="Choose start date/time for card.  If no start date, click 'X' and clear field."
                            class="mr-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearStartDateTime()"
                          />
                        </template>
                        <v-card>
                          <!-- <v-date-picker v-model="displayStartDate" v-on:click:date="startDateMenu = false; startTimeMenu = true"></v-date-picker> -->
                          <v-date-picker v-model="displayStartDate">
                          </v-date-picker>
                          <v-time-picker
                            v-model="displayStartTime"
                            format="24hr"
                            @click:minute="startDateMenu = false;setStartDateTime()"
                          >
                          </v-time-picker>
                          <v-spacer></v-spacer>
                          <v-flex class="text-xs-right">
                            <v-btn text color="red" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="menu = false">OK</v-btn>
                          </v-flex>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayEndDateTime"
                            label="End Date"
                            persistent-hint
                            hint="Choose end date/time for card. If no end date, click 'X' and clear field."
                            class="ml-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearEndDateTime()"
                          />
                        </template>
                        <v-date-picker v-model="displayEndDate">
                        </v-date-picker>
                        <v-time-picker
                          v-model="displayEndTime"
                          format="24hr"
                          @click:minute="endDateMenu = false;setEndDateTime()"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
                <br />
              </v-card>
            </v-col>
          </v-row>
          <v-layout wrap>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn v-if="this.editExclusion" color="blue darken-1" :disabled="!formValid" @click="save">Save</v-btn>
          </v-layout>
        </v-container>
      </template>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {
  props: {
    exclusion: {
      type: Object,
      required: true
    },
    sourceGroups: {
      type: Array,
      required: true
    },
    targetGroups: {
      type: Array,
      required: true
    },
    itemKey: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    min: 0,
    max: 10,
    editExclusion: [],
    startDateMenu: null,
    startTimeMenu: null,
    endDateMenu: false,
    endTimeMenu: false,
    dateTimeDialog: false,
    e7: null,
    dialog: false,
    displaySource: null,
    displayExcluded: null,
    displayStartDate: null,
    displayStartTime: null,
    displayStartDateTime: null,
    displayEndDate: null,
    displayEndTime: null,
    displayEndDateTime: null,
    sourceGroupModel: null,
    excludedGroupModel: null,
    newExclusion: false,
    defaultExclusion: {
      sourceGroup: {
        id: 0,
        name: null
      },
      excludedGroup: {
        id: 0,
        name: null
      },
      createdDate: moment(new Date()).toISOString(),
      startDate: null,
      endDate: null
    },
    originalStartDate: null,
    originalEndDate: null,
    originalExcludedId: 0
  }),
  created () {
    // this.initialize()
  },
  mounted () {
    this.initialize()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    exclusion: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (!newValue || newValue === 'undefined') {
          this.newExclusion = true
          this.editExclusion = JSON.parse(JSON.stringify(this.defaultExclusion))
        } else {
          this.newExclusion = false
          this.editExclusion = JSON.parse(JSON.stringify(newValue))
        }
        this.setupEdit()
      }
    },
    dateTimeDialog (val) {}
  },
  computed: {
    formValid () {
      // check if source is set
      if (this.sourceGroupModel === 0) {
        return false
      }
      // make sure the source and excluded group are not the same
      if (this.excludedGroupModel === this.sourceGroupModel) {
        return false
      }
      // check if data has changed
      var excludedIdUnchanged = (this.originalExcludedId === this.excludedGroupModel)
      var startDateUnchanged = (this.originalStartDate === this.displayStartDateTime)
      var endDateUnchanged = (this.originaEndDate === this.displayEndDateTime)

      if (this.exclusion != null) {
        if (excludedIdUnchanged && startDateUnchanged && endDateUnchanged) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    initialize () {
    },
    clearExcludedGroup () {
      this.excludedGroupModel = null
    },
    close () {
      delete this.editExclusion
      this.$emit('close-exclusion')
    },
    async save () {
      var response
      var request = {}
      var newExclusion = true
      if (this.editExclusion != null && this.editExclusion.id != null) {
        request.id = this.editExclusion.id
        newExclusion = false
      }
      request.sourceGroupId = this.sourceGroupModel
      if (this.excludedGroupModel !== undefined && this.excludedGroupModel !== 0) {
        request.excludedGroupId = this.excludedGroupModel
      }
      if (this.displayStartDateTime) {
        request.startDate = this.displayStartDate + 'T' + this.displayStartTime
      }
      if (this.displayEndDateTime) {
        request.endDate = this.displayEndDate + 'T' + this.displayEndTime
      }

      var excEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/exclusions`
      // If doesn't contain exclusion, it's a new exclusion
      if (newExclusion) {
        response = await rh.default.post(excEndpoint, request, true).catch(e => {
          this.errors.push(e)
        })
      } else {
        response = await rh.default.put(excEndpoint, request, true).catch(e => {
          this.errors.push(e)
        })
      }

      this.$emit('save-exclusion', JSON.stringify(response.data))
    },
    setStartDateTime () {
      var date = moment(
        this.displayStartDate + ' ' + this.displayStartTime
      )
      this.displayStartDateTime = this.formatDateTime(date)
    },
    clearStartDateTime () {
      this.localDate = null
      this.displayStartDate = ''
      this.displayStartTime = ''
      this.displayStartDateTime = ''
    },
    clearEndDateTime () {
      this.localDate = null
      this.displayEndDate = ''
      this.displayEndTime = ''
      this.displayEndDateTime = ''
    },
    setEndDateTime () {
      var date = moment(
        this.displayEndDate + ' ' + this.displayEndTime
      )
      this.displayEndDateTime = this.formatDateTime(date)
    },
    async setupEdit () {
      if (!this.editExclusion) {
        this.editExclusion = this.defaultExclusion
      }
      this.sourceGroupModel = this.editExclusion.sourceGroup.id
      if (this.editExclusion.excludedGroup && this.editExclusion.excludedGroup !== undefined) {
        this.excludedGroupModel = this.editExclusion.excludedGroup.id
      }

      this.displayStartDate = this.formatDate(this.editExclusion.startDate)
      this.displayStartTime = this.formatTime(this.editExclusion.startDate)
      this.displayStartDateTime = this.formatDateTime(this.editExclusion.startDate)
      this.localDate = !this.editExclusion.endDate ? null : moment(this.editExclusion.endDate)
      this.displayEndDate = this.formatDate(this.localDate)
      this.displayEndTime = this.formatTime(this.localDate)
      this.displayEndDateTime = this.formatDateTime(this.localDate)

      this.originalStartDate = this.displayStartDateTime
      this.originalEndDate = this.displayEndDateTime
      this.originalExcludedId = this.excludedGroupModel
    },
    formatDateTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD HH:mm')
    },
    formatDate (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD')
    },
    formatTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('HH:mm')
    }
  }
}
</script>
<style>
.onlyDigitInput input[type="number"] {
  -moz-appearance: textfield;
}
.onlyDigitInput input::-webkit-outer-spin-button,
.onlyDigitInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
